// Cronograma de conferencias por sede. Sale del Excel "Cronograma mexico.xlsx"
// que mandó el cliente el 27/09/2026, con los acentos corregidos y cada tema
// partido en título y detalle.
//
// Los logos van en public/assets/images/cronograma/. Con `logo: null` la
// página muestra un espacio con las iniciales. Los de las cinco instituciones
// y el de Fernando Torres Immigration (RCIC R532615, fernandotorresimmigration.ca)
// se tomaron de sus sitios oficiales el 27/09/2026 y están pendientes de que el
// cliente los valide. La foto de Evianny de los Santos sale de su
// perfil público (@eviannycareer), también a la espera de que el cliente la
// confirme o mande otra.
//
// Hora local de México, 24 h. El Excel no trae duración: se muestra solo el
// inicio.

export const ponentes = {
    evianny: {
        nombre: 'Evianny de los Santos',
        iniciales: 'EdlS',
        logo: null,
        // Persona, no institución: foto en círculo en lugar de logo.
        foto: '/assets/images/cronograma/evianny.jpg'
    },
    redriver: {
        nombre: 'Red River College Polytechnic',
        iniciales: 'RRC',
        logo: '/assets/images/cronograma/redriver.svg'
    },
    saskpolytech: {
        nombre: 'Saskatchewan Polytechnic',
        iniciales: 'SP',
        logo: '/assets/images/cronograma/saskpolytech.webp'
    },
    assiniboine: {
        nombre: 'Assiniboine College',
        iniciales: 'AC',
        logo: '/assets/images/cronograma/assiniboine.png'
    },
    nait: {
        nombre: 'NAIT',
        iniciales: 'NAIT',
        logo: '/assets/images/cronograma/nait.svg'
    },
    uwinnipeg: {
        nombre: 'University of Winnipeg',
        iniciales: 'UW',
        logo: '/assets/images/cronograma/uwinnipeg.png'
    },
    fernandotorres: {
        nombre: 'Fernando Torres Immigration',
        iniciales: 'FT',
        logo: '/assets/images/cronograma/fernandotorres.png'
    }
};

// El mismo tema en las tres sedes.
const temas = {
    evianny: {
        titulo: 'Consigue un trabajo en Canadá',
        detalle: 'Estrategias, empleadores, CV que sí funcionan y todo lo que debes saber para conseguir un empleo en Canadá.'
    },
    redriver: {
        titulo: 'La ciudad del futuro de Canadá',
        detalle: 'Oportunidades de estudio y trabajo en Winnipeg, Manitoba.'
    },
    saskpolytech: {
        titulo: 'La joya escondida de Canadá',
        detalle: 'Sus oportunidades de estudio y trabajo en Saskatchewan.'
    },
    assiniboine: {
        titulo: 'Una ciudad con un enorme potencial de crecimiento',
        detalle: 'Oportunidades de estudio y trabajo en Brandon, Manitoba.'
    },
    nait: {
        titulo: 'El lugar con el tamaño perfecto',
        detalle: 'Estudiar, vivir y trabajar en Edmonton, Alberta.'
    },
    uwinnipeg: {
        titulo: 'Viaja en familia a Canadá',
        detalle: 'Estudia una maestría que te abrirá las puertas laborales en Canadá.'
    },
    fernandotorres: {
        titulo: 'Las vías reales para llegar a Canadá',
        detalle: 'Charla migratoria con Fernando Torres, consultor migratorio.'
    }
};

const charla = (hora, clave) => ({ hora, clave, ...temas[clave] });

// Las claves de sede son los slugs de src/data/events.js.
const cronograma = {
    cdmx: [
        charla('16:00', 'evianny'),
        charla('16:30', 'redriver'),
        charla('17:00', 'saskpolytech'),
        charla('17:30', 'assiniboine'),
        charla('18:00', 'nait'),
        charla('18:30', 'uwinnipeg'),
        charla('19:00', 'fernandotorres')
    ],
    guadalajara: [
        charla('16:00', 'evianny'),
        charla('16:30', 'assiniboine'),
        charla('17:00', 'nait'),
        charla('17:30', 'redriver'),
        charla('18:00', 'saskpolytech'),
        charla('18:30', 'uwinnipeg'),
        charla('19:00', 'fernandotorres')
    ],
    // En el Excel, Saskatchewan Polytechnic no está en Monterrey.
    monterrey: [
        charla('09:00', 'evianny'),
        charla('09:30', 'redriver'),
        charla('10:00', 'nait'),
        charla('10:30', 'assiniboine'),
        charla('11:00', 'uwinnipeg'),
        charla('11:30', 'fernandotorres')
    ]
};

export default cronograma;
